"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var Scanner = function Scanner(tokens) {
  var _this = this;

  var _index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  (0, _classCallCheck2["default"])(this, Scanner);
  this.tokens = [];
  this.index = 0;

  this.read = function () {
    var token = _this.tokens[_this.index];

    if (token) {
      return token;
    }

    return false;
  };

  this.next = function () {
    _this.index += 1;
  };

  this.isEnd = function () {
    return _this.index >= _this.tokens.length;
  };

  this.getIndex = function () {
    return _this.index;
  };

  this.setIndex = function (index) {
    _this.index = index;
    return index;
  };

  this.getRestTokenCount = function () {
    return _this.tokens.length - _this.index - 1;
  };

  this.getNextByToken = function (token) {
    var currentTokenIndex = _this.tokens.findIndex(function (eachToken) {
      return eachToken === token;
    });

    if (currentTokenIndex > -1) {
      if (currentTokenIndex + 1 < _this.tokens.length) {
        return _this.tokens[currentTokenIndex + 1];
      }

      return null;
    }

    throw Error("token ".concat(token.value.toString(), " not exist in scanner."));
  };

  this.getTokenByCharacterIndex = function (characterIndex) {
    if (characterIndex === null) {
      return null;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _this.tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var token = _step.value;

        if (characterIndex >= token.position[0] && characterIndex - 1 <= token.position[1]) {
          return token;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  };

  this.getPrevTokenByCharacterIndex = function (characterIndex) {
    var prevToken = null;
    var prevTokenIndex = null;

    _this.tokens.forEach(function (token, index) {
      if (token.position[1] < characterIndex - 1) {
        prevToken = token;
        prevTokenIndex = index;
      }
    });

    return {
      prevToken: prevToken,
      prevTokenIndex: prevTokenIndex
    };
  };

  this.getNextTokenFromCharacterIndex = function (characterIndex) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = _this.tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var token = _step2.value;

        if (token.position[0] > characterIndex) {
          return token;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return null;
  };

  this.addToken = function (token) {
    var _this$getPrevTokenByC = _this.getPrevTokenByCharacterIndex(token.position[0]),
        prevToken = _this$getPrevTokenByC.prevToken,
        prevTokenIndex = _this$getPrevTokenByC.prevTokenIndex;

    if (prevToken) {
      _this.tokens.splice(prevTokenIndex + 1, 0, token);
    } else {
      _this.tokens.unshift(token);
    }
  };

  this.tokens = tokens.slice();
  this.index = _index;
};

exports.Scanner = Scanner;